export const baseURL="https://backend.hr.nibhashrdsolutions.com/"
//"https://nibhashr.onrender.com/"//https://backend.hr.nibhashrdsolutions.com/"//http://localhost:4000/"//"